module.exports = __webpack_public_path__ + "img/mail.32b4f502.svg";